import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter043() {
  return <KbChapterPage slug="chapter-043" />;
}

(Chapter043 as unknown as { path: string }).path = "/theory-album/043";
